import {
  reactive,
  watch,
} from 'vue'
import axios from 'axios'

import { requestFeeds } from '@/api/feeds'

export default function useGetFeedsData({ ticker, requestParams }) {
  const feedsData = reactive({
    items: [],
    pagination: {
      nextUrl: null,
    },
    isLoading: false,
    hasLoadingError: false,
  })

  const _fetchData = ({ api }) => {
    feedsData.isLoading = true
    feedsData.hasLoadingError = false

    return api
      .then((response) => {
        const {
          items,
          pagination,
        } = response.data

        feedsData.pagination.nextUrl = pagination.next_url
        feedsData.items = [...feedsData.items, ...items]
        feedsData.isLoading = false

        return response.data
      })
      .catch(() => {
        feedsData.isLoading = false
        feedsData.hasLoadingError = true
      })
  }

  const getFeedsData = () => {
    const { nextUrl } = feedsData.pagination

    if (nextUrl) {
      return _fetchData({ api: axios.get(nextUrl) }) // `nextUrl` 已包含網址和參數
    }

    return _fetchData({ api: requestFeeds({ params: requestParams.value }) })
  }

  const clearFeedsData = () => {
    feedsData.items = []
    feedsData.pagination.nextUrl = null
    feedsData.isLoading = false
    feedsData.hasLoadingError = false
  }

  watch(
    () => ticker,
    () => {
      clearFeedsData()
      getFeedsData()
    },
  )

  return {
    feedsData,
    getFeedsData,
    clearFeedsData,
  }
}
